import { useQuery } from '@tanstack/react-query'
import { storeApi } from '@/api/store'
import { products as staticProducts } from '@/data/products'
import type { Product } from '@/types'

/**
 * The current brand's catalog, fetched at runtime from /api/store/products
 * (scoped to the storefront's tenant by Host on the backend). Falls back to the
 * built-in static catalog only if the request fails or returns nothing, so the
 * page always renders something. This is what makes each brand show its OWN
 * products instead of the baked-in defaults.
 */
export function useProducts(): { products: Product[]; isLoading: boolean } {
  const { data, isLoading } = useQuery({
    queryKey: ['store-products'],
    queryFn: () => storeApi.getProducts(),
    staleTime: 5 * 60 * 1000,
  })
  const products = data && data.length > 0 ? data : staticProducts
  return { products, isLoading }
}
